var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#0061ED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99854 8.81242C3.99854 5.56511 6.71216 2.94043 9.99456 2.94043C13.2862 2.94043 15.9998 5.56511 15.9998 8.81242C15.9998 10.4488 15.4047 11.968 14.4252 13.2556C13.3446 14.6759 12.0127 15.9135 10.5135 16.8848C10.1704 17.1093 9.86073 17.1263 9.48415 16.8848C7.97643 15.9135 6.64453 14.6759 5.57318 13.2556C4.59294 11.968 3.99854 10.4488 3.99854 8.81242ZM8.0192 8.99562C8.0192 10.0835 8.9069 10.9391 9.99533 10.9391C11.0845 10.9391 11.9807 10.0835 11.9807 8.99562C11.9807 7.91624 11.0845 7.019 9.99533 7.019C8.9069 7.019 8.0192 7.91624 8.0192 8.99562Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default ForwardRef;